'use client';

import Spinner from '@/components/ui/spinner';
import { useCurrentUser } from '@/features/auth/hooks/use-current-user';
import { UserRole } from '@/features/auth/types';
interface RoleProtectorProps {
  children: React.ReactNode;
  roles: UserRole[];
}
export function RoleProtector({
  children,
  roles
}: RoleProtectorProps) {
  const {
    data: user,
    isPending
  } = useCurrentUser();
  if (isPending) {
    return <div className="flex items-center justify-center">
        <Spinner className="h-8 w-8" />
      </div>;
  }
  if (!user || !roles.includes(user.role)) {
    return null;
  }
  return <>{children}</>;
}